import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// hooks
import { useShowModal } from 'hooks'
// constants
import { Modals } from 'constants/modals'

const CreateKPIButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.KPI_CREATE_MODAL })

  const createKPI = () => showModal()

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} onClick={createKPI}>
      Create Indicator
    </Button>
  )
}

export default CreateKPIButton
